import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { getErrorMessage } from "@/lib/api";
import { Sparkles } from "lucide-react";

const AuthPage = () => {
  const isLogin = useLocation().pathname === "/connexion";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (isLogin) {
        await login(email, password);
        toast.success("Bon retour !");
      } else {
        await register(name, email, password);
        toast.success("Bienvenue ! 5 crédits offerts 🎬");
      }
      navigate("/studio");
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="noise relative min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-[#8B5CF6]/20 blur-[130px] pointer-events-none" />
      <div className="relative w-full max-w-md rounded-3xl border border-border bg-card p-8 glow-purple" data-testid="auth-card">
        <div className="flex items-center gap-2 justify-center">
          <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#8B5CF6] to-[#EC4899] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" />
          </span>
          <h1 className="font-display text-xl font-bold" data-testid="auth-title">
            {isLogin ? "Connexion" : "Créer un compte"}
          </h1>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          {!isLogin && (
            <Input placeholder="Votre nom" value={name} onChange={(e) => setName(e.target.value)} data-testid="auth-name-input" />
          )}
          <Input type="email" required placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="auth-email-input" />
          <Input type="password" required minLength={6} placeholder="Mot de passe (6 caractères min.)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="auth-password-input" />
          <Button type="submit" disabled={busy} className="w-full bg-gradient-to-r from-[#8B5CF6] to-[#EC4899] text-white border-0" data-testid="auth-submit-button">
            {busy ? "Un instant…" : isLogin ? "Se connecter" : "Créer mon compte"}
          </Button>
        </form>
        <p className="mt-6 text-center text-sm text-muted-foreground" data-testid="auth-switch-note">
          {isLogin ? (
            <>Pas encore de compte ? <Link to="/inscription" className="text-[#8B5CF6] hover:underline" data-testid="auth-switch-signup-link">S'inscrire</Link></>
          ) : (
            <>Déjà inscrit ? <Link to="/connexion" className="text-[#8B5CF6] hover:underline" data-testid="auth-switch-login-link">Se connecter</Link></>
          )}
        </p>
      </div>
    </div>
  );
};

export default AuthPage;
